/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { useSellers } from 'utils/sellerUtils'
import UiSelectWithGraphics from 'components/Ui/UiSelectWithGraphics'
import { useTypedSelector } from 'helpers/reducers'

interface UiSellerSelectProps {
    label?: string
    selected: string | number | null
    setSelected: (value: string | number | null) => void
    disabled?: boolean
    className?: string
    /** When true (default), empty selection is filled with the logged-in seller. */
    autoSelectCurrentUser?: boolean
}

const UiSellerSelect: React.FC<UiSellerSelectProps> = ({
    label,
    selected,
    setSelected,
    disabled,
    className,
    autoSelectCurrentUser = true,
}) => {
    const { t } = useTranslation()
    const { selectOptions } = useSellers()
    const session = useTypedSelector((state) => state.sessionState.session)

    useEffect(() => {
        if (disabled || !autoSelectCurrentUser) {
            return
        }

        if ((selected === null || selected === undefined || selected === '') && session?.uid) {
            setSelected(session.uid)
        }
    }, [selected, session?.uid, setSelected, disabled, autoSelectCurrentUser])

    return (
        <UiSelectWithGraphics
            options={selectOptions}
            selected={selected}
            setSelected={setSelected}
            disabled={disabled}
            className={clsx('UiSellerSelect', className)}
            label={''}
        />
    )
}

export default UiSellerSelect
